import { getHashFromObject } from '@/legacy-src/utilities/codingPublicHash'

import type { CartParams } from '@/src/domains/cart/types'

export const hashCartParams = (params: Partial<CartParams>) => getHashFromObject(params)
